<template>
  <div class="page-container order-info">
    <div class="main">
      <page :url="url" :form="form" :formRules="formRules" @reset="reset" :isShowSearch="isShowSearch">
        <template slot="pageHeader">
          <div class="order-summary">
            <div class="summary-item">{{ $t('message.orderAmountSummary') }}: <span> {{ totalAmount }}</span></div>
            <div class="summary-item">{{ $t('message.orderFeeSummary') }}: <span>{{ totalFee }}</span></div>
            <div class="summary-item">{{ $t('message.orderActualSummary') }}: <span>{{ totalActualAmount }}</span></div>
          </div>
        </template>

        <template slot="tableSearch">
          <el-form-item :label="$t('text.merchantOrderNumber')">
            <el-input v-model="form.merchantOrderId"
                      :placeholder="$t('message.inputMerchantOrderId')"
                      style="width: 240px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.orderNumber')">
            <el-input v-model="form.orderId"
                      :placeholder="$t('message.inputOrderId')"
                      style="width: 240px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.channelOrderNumber')">
            <el-input v-model="form.channelOrderId"
                      :placeholder="$t('message.inputChannelOrderIdForQuery')"
                      style="width: 240px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.agent')">
            <el-select v-model="form.agentId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="item in agentList"
                         :key="item.agentId"
                         :label="item.agentId + '-' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()"
                        :label="$t('text.merchant')">
            <el-select v-model="form.appId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="merchant in merchantList"
                         :label="merchant.value + '-' + merchant.name"
                         :key="merchant.value"
                         :value="merchant.value"/>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.paymentChannel')">
            <el-select v-model="form.channelId"
                       filterable
                       clearable
                       :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="item in payOption"
                         :key="item.channelId"
                         :label="item.channelName"
                         :value="item.channelId"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.orderStatus')">
            <el-select v-model="selectedStatuses"
                       :placeholder="$t('message.chooseOne')"
                       multiple>
              <el-option :label="$t('option.all')"
                         value="all"/>
              <el-option :label="$t('orderStatus.00')"
                         value="00"/>
              <el-option :label="$t('orderStatus.01')"
                         value="01"/>
              <el-option :label="$t('orderStatus.02')"
                         value="02"/>
              <el-option :label="$t('orderStatus.03')"
                         value="03"/>
              <el-option :label="$t('orderStatus.99')"
                         value="99"/>
              <el-option :label="$t('orderStatus.04')"
                         value="04"/>
              <el-option :label="$t('orderStatus.06')"
                         value="06"/>
              <el-option :label="$t('orderStatus.07')"
                         value="07"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.callbackStatus')">
            <el-select v-model="form.callbackStatus"
                       style="width: 100px"
                       :placeholder="$t('text.callbackStatus')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option :label="$t('callbackStatus.00')"
                         value="00"/>
              <el-option :label="$t('text.callbackSuccess')"
                         value="01"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.settlementStatus')">
            <el-select v-model="form.settlementStatus"
                       style="width: 100px"
                       :placeholder="$t('text.settlementStatus')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option :label="$t('settlementStatus.00')"
                         value="00"/>
              <el-option :label="$t('settlementStatus.01')"
                         value="01"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.amount')">
            <el-input v-model="form.amount" :placeholder="$t('message.inputAmount')" maxlength="20"/>
          </el-form-item>

          <el-form-item :label="$t('text.realPayAmount')">
            <el-input v-model="form.actualAmount" :placeholder="$t('message.inputAmount')" maxlength="20"/>
          </el-form-item>

          <el-form-item :label="$t('text.cardPaymentAccount')">
            <el-input v-model="form.cardPaymentAccount"
                      :placeholder="$t('message.inputAccountNum')"
                      style="width: 180px"
                      maxlength="50"/>
          </el-form-item>

          <el-form-item :label="$t('text.cardType')">
            <el-select v-model="form.upstream" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')" value=""></el-option>
              <el-option v-for="item in cardTypeList"
                         :key="item.value"
                         :label="item.name"
                         :value="item.value"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.accountNumber')">
            <el-input v-model="form.accountNum"
                      :placeholder="$t('message.inputAccountNum')"
                      style="width: 180px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.phoneNumber')">
            <el-input v-model="form.customerPhone"
                      :placeholder="$t('message.inputPhoneNumber')"
                      style="width: 180px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.name')">
            <el-input v-model="form.customerName"
                      :placeholder="$t('message.inputName')"
                      style="width: 160px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.idNumber')">
            <el-input v-model="form.customerCert"
                      :placeholder="$t('message.inputCustomerCert')"
                      style="width: 140px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.creationTime')"
                        prop="createTimeDate"
                        :inline-message="true"
                        :error="showCreateTimeDateError">
            <el-date-picker v-model="createTimeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="createTimeChange"/>
          </el-form-item>
          <el-form-item :label="$t('text.finishTime')"
                        prop="endTimeDate"
                        :inline-message="true"
                        :error="showEndTimeDateError">
            <el-date-picker v-model="endTimeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="endTimeChange"/>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button v-if="!ROLE_TYPE.isCustomerServiceStaff() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
                     :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.exportToExcel') }}
          </el-button>
          <el-button v-if="!ROLE_TYPE.isCustomerServiceStaff() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
                     :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="exportToS3Detail"
                     size="small">
            {{ $t('text.exportToZip') }}
          </el-button>
          <el-button v-if="!ROLE_TYPE.isCustomerServiceStaff() && !ROLE_TYPE.isBusinessCustomerServiceManage()"
                     :loading="loading"
                     :disabled="exporting"
                     type="primary"
                     @click="downloadExportZipFile"
                     size="small">
            {{ $t('text.downloadZip') }}
          </el-button>

          <el-button :loading="loading" type="primary" size="mini" plain @click="countAmount">
            {{ $t("text.statistics") }}
          </el-button>

          <el-button v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isCustomerServiceStaff() &&
                           !ROLE_TYPE.isBusinessCustomerServiceManage()"
                     type="primary"
                     size="mini"
                     plain
                     @click="popBatchCallbackFileSelect">
            {{ $t('text.batchCallback') }}
            <input type="file"
                   ref="callbackFile"
                   class="file-input"
                   @change="handleBatchCallbackUpdate"
                   style="display: none"/>
          </el-button>
          <el-button v-if="ROLE_TYPE.isManager()"
                     type="primary"
                     size="mini"
                     plain
                     @click="popSyncFileSelect">
            {{ $t('text.batchSync') }}
            <input type="file"
                   ref="SyncFile"
                   class="file-input"
                   @change="handleBulkSyncOrderStatus"
                   style="display: none"/>
          </el-button>

          <el-button v-if="ROLE_TYPE.isManager()"
                     type="primary"
                     size="mini"
                     plain
                     @click="popBatchBankStatementFileSelect">
            {{ $t('text.bankCardCallback') }}
            <input type="file"
                   ref="bankStatementFile"
                   class="file-input"
                   @change="importStatement"
                   style="display: none"/>
          </el-button>
          <el-button v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isCustomerServiceStaff() &&
                           !ROLE_TYPE.isBusinessCustomerServiceManage()"
                     type="primary"
                     size="mini"
                     plain
                     @click="handleManualSettlement">
            {{ $t('text.manualSettlement') }}
          </el-button>
          <el-button
              v-if="ROLE_TYPE.isManager() && !ROLE_TYPE.isCustomerServiceStaff() &&
                    !ROLE_TYPE.isBusinessCustomerServiceManage()"
              type="primary"
              size="mini"
              plain
              @click="handleCreateTestingRepaymentLink">
            {{ $t('text.testOrder') }}
          </el-button>
          <el-button
              v-if="ROLE_TYPE.isManager()"
              type="primary"
              size="mini"
              plain
              @click="handleOrderRestoration">
            {{ $t('text.restoration') }}
          </el-button>

          <el-button v-if="ROLE_TYPE.isManager()"
                     type="primary"
                     plain
                     size="mini"
                     @click="showLogDialog()">
            {{ $t('text.log') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column prop="orderId"
                           width="310px"
                           :label="$t('text.orderNumber')"
                           fixed
                           align="center">
            <template slot-scope="{ row }">
              <div class="orderStyle" style="margin-bottom: 0">
                <el-tag size="mini">{{ $t('text.collection') }}</el-tag>
                {{ row.orderId }}
              </div>
              <div class="orderStyle" style="margin-bottom: 0">
                <el-tag size="mini" type="success">{{ $t('text.merchant') }}</el-tag>
                {{ row.merchantOrderId }}
              </div>
              <div class="orderStyle">
                <el-tag size="mini" type="warning">{{ $t('text.channel') }}</el-tag>
                <span v-if="row.channelOrderId">{{ row.channelOrderId }}</span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="onlineTopUpOrderId"
                           width="120px"
                           :label="$t('text.onlineTopUpOrderId')"
                           align="center"/>
          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="agentId"
                           width="180px"
                           :label="$t('text.agent')"
                           align="center">
            <template slot-scope="{ row }">
              <div>{{ row.agentId }}</div>
              <div>{{ row.agentName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="appId"
                           width="180px"
                           :label="$t('text.merchant')"
                           align="center">
            <template slot-scope="{ row }">
              <div>{{ row.appId }}</div>
              <div>{{ row.merchantName }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="channelName"
                           width="180px"
                           :label="$t('text.paymentChannel')"
                           align="center"/>
          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="providerName"
                           width="180px"
                           :label="$t('text.paymentChannelProvider')"
                           align="center"/>
          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="cardPaymentAccount"
                           width="180px"
                           :label="$t('text.cardPaymentAccount')"
                           align="center"/>
          <el-table-column prop="amount"
                           width="110px"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.orderAmount')"
                           align="center"/>
          <el-table-column prop="realPayAmount"
                           width="110px"
                           :formatter="$formatter.FenToYuanToThousandth"
                           :label="$t('text.realPay')"
                           align="center"/>
          <!--          <el-table-column prop="discountedAmount"-->
          <!--                           width="110px"-->
          <!--                           :formatter="$formatter.FenToYuanToThousandth"-->
          <!--                           :label="$t('text.discountedAmount')"-->
          <!--                           align="center"/>-->
          <el-table-column prop="createDate"
                           width="160px"
                           :label="$t('text.creationTime')"
                           align="center">
            <template slot-scope="{ row }">
              {{ $formatter.formatDate(null, null, row.createDate + row.createTime, null) }}
            </template>
          </el-table-column>
          <el-table-column prop="submitDate"
                           width="160px"
                           :label="$t('text.submittedTime')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.submitDate">
                {{ $formatter.formatDate(null, null, row.submitDate + row.submitTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="endDate"
                           width="160px"
                           :label="$t('text.finishTime')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.endDate">
                {{ $formatter.formatDate(null, null, row.endDate + row.endTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="status"
                           width="130px"
                           :label="$t('text.orderStatus')"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="medium"
                      :type="scope.row.status === '00'
                               ? 'warning'
                               : scope.row.status === '01'
                               ? 'success'
                               : scope.row.status === '02' || scope.row.status === '03'
                               ? 'danger'
                               : scope.row.status === '07'
                               ? 'info'
                               : 'primary'">
                {{ $formatter.formatOrderStatus(null, null, scope.row.status, null) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="callbackStatus"
              :formatter="$formatter.formatCallBackStatus"
              width="80px"
              :label="$t('text.whetherToCallback')"
              align="center"/>
          <el-table-column prop="settlementStatus"
                           :formatter="$formatter.formatSettlementStatus"
                           width="80px"
                           :label="$t('text.whetherToSettle')"
                           align="center"/>
          <el-table-column prop="settlementCycle"
                           width="80px"
                           :label="$t('text.settlementCycle')"
                           align="center"/>
          <el-table-column prop="feeRate"
                           width="80px"
                           :label="$t('text.feeRate')"
                           align="center"/>
          <el-table-column prop="fee"
                           width="80px"
                           :formatter="$formatter.FenToYuan3ToThousandth"
                           :label="$t('text.fee')"
                           align="center"/>
          <el-table-column prop="accountNum"
                           width="140px"
                           :label="$t('text.accountNumber')"
                           align="center">
            <template slot-scope="{ row }">
              <span v-if="row.accountNum">{{ row.accountNum }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerPhone"
                           width="140px"
                           :label="$t('text.phoneNumber')"
                           align="center">
            <template slot-scope="{ row }">
              <span v-if="row.customerPhone">{{ row.customerPhone }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerName"
                           width="160px"
                           :label="$t('text.name')"
                           align="center">
            <template slot-scope="{ row }">
              <span v-if="row.customerName">{{ row.customerName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerCert"
                           width="130px"
                           :label="$t('text.idNumber')"
                           align="center">
            <template slot-scope="{ row }">
              <span v-if="row.customerCert">{{ row.customerCert }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column prop="createMessage"
                           width="160px"
                           :label="$t('text.createMessage')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.createMessage">
                <el-popover v-if="row.createMessage && row.createMessage.length > 10"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="row.createMessage">
                  <div slot="reference" class="remark">{{ row.createMessage }}</div>
                </el-popover>
                <div v-else>{{ row.createMessage }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column prop="queryMessage"
                           width="160px"
                           :label="$t('text.queryMessage')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.createMessage">
                <el-popover v-if="row.queryMessage && row.queryMessage.length > 10"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="row.queryMessage">
                  <div slot="reference" class="remark">{{ row.queryMessage }}</div>
                </el-popover>
                <div v-else>{{ row.queryMessage }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column prop="msg"
                           width="160px"
                           :label="$t('text.message')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.msg">
                <el-popover v-if="row.msg && row.msg.length > 10"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="row.msg">
                  <div slot="reference" class="remark">{{ row.msg }}</div>
                </el-popover>
                <div v-else>{{ row.msg }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="sysRemark"
                           width="150px"
                           :label="$t('text.systemRemark')"
                           align="center">
            <template slot-scope="{ row }">
              <div v-if="row.sysRemark">
                <el-popover v-if="row.sysRemark && row.sysRemark.length > 10"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="row.sysRemark">
                  <div slot="reference" class="remark">{{ row.sysRemark }}</div>
                </el-popover>
                <div v-else>{{ row.sysRemark }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           :label="$t('text.actions')"
                           :width="ROLE_TYPE.isManager() ? '210' : '180'"
                           align="center">
            <template slot-scope="scope">
<!--              <el-button type="primary"-->
<!--                         plain-->
<!--                         size="mini"-->
<!--                         @click="orderRefresh(scope.row)">-->
<!--                {{ $t('text.refresh') }}-->
<!--              </el-button>-->
              <el-button
                         v-if="['01','02'].includes(scope.row.status)"
                         type="success"
                         plain
                         size="mini"
                         @click="orderNotify(scope.row)">
                {{ $t('text.callback') }}
              </el-button>
              <el-button v-if="ROLE_TYPE.isManager() && !['01','02'].includes(scope.row.status)"
                         type="warning"
                         size="mini"
                         plain
                         @click="handleModify(scope.row)">
                {{ $t('text.modify') }}
              </el-button>
              <el-button v-if="ROLE_TYPE.isManager()"
                         type="danger"
                         size="mini"
                         plain
                         :disabled="scope.row.status !== '02'"
                         @click="handleReverse(scope.row)">
                {{ $t('text.reverse') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
      <OrderModify :is-show-modify-dialog.sync="isShowModifyDialog"
                   :id="id" :order-amount="orderAmount"/>
      <OrderReverse :is-show-reverse-dialog.sync="isShowReverseDialog"
                   :id="id" :order-amount="orderAmount"/>
      <ManualSettlementDialog :isShowManualSettlementDialog.sync="isShowManualSettlementDialog"/>
      <CreateTestCollectionOrderDialog
          :isShowCreateTestCollectionOrderDialog.sync="isShowCreateTestCollectionOrderDialog"
      />
      <OrderRestorationDialog
          :isShowOrderRestorationDialog.sync="isShowOrderRestorationDialog"
      />
      <OrderCardCollectionLogDialog
          v-if="isShowLogDialog"
          :isShowLogDialog.sync="isShowLogDialog"
      >
      </OrderCardCollectionLogDialog>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import moment from "moment";
import OrderModify from "./components/OrderModify.vue";
import ManualSettlementDialog from "./components/ManualSettlementDialog.vue";
import {ROLE_TYPE} from "@/utils/Constant";
import CreateTestCollectionOrderDialog from "@/views/order/components/CreateTestCollectionOrderDialog.vue";
import OrderRestorationDialog from "@/views/order/components/OrderRestorationDialog.vue";
import OrderCardCollectionLogDialog from "./OrderCardCollectionLogDialog.vue";
import OrderReverse from "./components/OrderReverse.vue";

export default {
  name: "Systems",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE;
    },
    selectedStatuses: {
      get() {
        return this.form.status ? this.form.status.split(',') : [];
      },
      set(value) {
        this.form.status = value.join(',');
      }
    }
  },
  components: {
    OrderReverse,
    OrderCardCollectionLogDialog,
    CreateTestCollectionOrderDialog,
    OrderRestorationDialog,
    page: Page,
    qrcode: VueQrcode,
    OrderModify: OrderModify,
    ManualSettlementDialog: ManualSettlementDialog
  },
  data() {
    return {
      url: "/order/selectList?payType=110",
      action: "",
      createTimeDate: null,
      showCreateTimeDateError: "",
      endTimeDate: null,
      showEndTimeDateError: "",
      payOption: [],
      logDialogValue: [],
      id: "",
      orderAmount: "",
      loading: false,
      exporting: false,
      isShowSearch: false,
      form: {
        orderId: "",
        merchantOrderId: "",
        channelOrderId: "",
        appId: "",
        channelId: "",
        channelIds: "",
        startCreateDate: "",
        endCreateDate: "",
        startEndDate: "",
        endEndDate: "",
        status: "",
        callbackStatus: "",
        amount: "",
        actualAmount: "",
        cardPaymentAccount:"",
        settlementStatus: "",
        showOrderCount: "01",
        checkoutSubmit: "",
        isCardGroup: true,
      },
      formRules: {
        createTimeDate: [
          {
            type: "date",
            trigger: "change",
            validator: this.validateDate
          }
        ],
        endTimeDate: [
          {
            type: "date",
            trigger: "change",
            validator: this.validateDate
          }
        ]
      },
      showDialog: false,
      formData: null,
      totalAmount: "",
      totalFee: "",
      totalActualAmount: "",
      merchantList: [],
      agentList: [],
      cardTypeList: [],
      isShowModifyDialog: false,
      isShowReverseDialog: false,
      isShowManualSettlementDialog: false,
      isShowCreateTestCollectionOrderDialog: false,
      isShowOrderRestorationDialog: false,
      isShowLogDialog: false,
    };
  },
  methods: {
    createTimeChange(e) {
      if (e) {
        this.form.startCreateDate = e[0];
        this.form.endCreateDate = e[1];
      } else {
        this.form.startCreateDate = "";
        this.form.endCreateDate = "";
      }
    },
    endTimeChange(e) {
      if (e) {
        this.form.startEndDate = e[0];
        this.form.endEndDate = e[1];
      } else {
        this.form.startEndDate = "";
        this.form.endEndDate = "";
      }
    },
    reset() {
      let start = moment().format("yyyyMMDD");
      let end = moment().format("yyyyMMDD");
      this.form.startCreateDate = start;
      this.form.endCreateDate = end;
      this.createTimeDate = [start, end];

      this.form.startEndDate = "";
      this.form.endEndDate = "";
      this.endTimeDate = null;

      this.form.showOrderCount = "01";

      this.totalAmount = "";
      this.totalFee = "";
      this.totalActualAmount = "";
    },
    handleModify(row) {
      this.id = row.orderId;
      this.orderAmount = this.$formatter.FenToYuanToThousandth(null, null, row.amount, null);
      this.isShowModifyDialog = true;
    },
    handleReverse(row) {
      this.id = row.orderId;
      this.orderAmount = this.$formatter.FenToYuanToThousandth(null, null, row.amount, null);
      this.isShowReverseDialog = true;
    },
    handleManualSettlement() {
      this.isShowManualSettlementDialog = true;
    },
    handleCreateTestingRepaymentLink() {
      this.isShowCreateTestCollectionOrderDialog = true;
    },
    handleOrderRestoration() {
      this.isShowOrderRestorationDialog = true;
    },
    add() {
      this.action = "addMerchant";
      this.formData = null;
      this.showDialog = true;
    },
    edit(row) {
      this.action = "editMerchant";
      this.formData = row;
      this.showDialog = true;
    },
    orderNotify(row) {
      let orderId = row.orderId;

      this.$confirm(
          this.$t('message.confirmNotifyingOrder'),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: "warning"
          })
          .then(() => {
            this.axios
                .post("/order/notifyOrder", {orderId: orderId})
                .then((res) => {
                  if (res.code === 200) {
                    this.$bus.$emit("refresh"); //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg
                    });
                  }
                });
          })
          .catch(() => {
          });
    },
    countAmount() {
      this.loading = true;
      this.clearCountAmount();

      let param = {};

      let showOrderCount = this.form.showOrderCount;
      if (showOrderCount !== "01") {
        this.totalAmount = "";
        this.totalFee = "";
        this.totalActualAmount = "";
        return;
      }

      for (let key in this.form) {
        let value = this.form[key];
        if (value !== "" && value !== null) {
          param[key] = value;
        }
      }
      param.payType = 110;
      this.$axios.get("/order/amountCount", {params: param}).then((res) => {
        if (res.code === 200) {
          this.totalAmount = this.$formatter.FenToYuanToThousandth(
              null,
              null,
              res.data.amount,
              null
          );
          this.totalFee = this.$formatter.FenToYuanToThousandth(
              null,
              null,
              res.data.fee,
              null
          );
          this.totalActualAmount = this.$formatter.FenToYuanToThousandth(
              null,
              null,
              res.data.actualAmount,
              null
          );
        } else if (res.code === 500) {
          this.$notify.error({
            title: this.$t("text.prompt"),
            message: res.msg,
          });
        } else {
          this.$notify.error({
            title: this.$t("text.prompt"),
            message: this.$t("message.queryFailed"),
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    clearCountAmount() {
      this.totalAmount = "";
      this.totalFee = "";
      this.totalActualAmount = "";
    },
    exportToS3Detail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/order/selectListForExportToS3?payType=110", {params: this.form})
          .then((res) => {
            if (res.code === 200) {
              this.$notify.success({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
      });
      this.exporting = false;
      this.loading = false;
    },
    downloadExportZipFile() {
      this.axios
          .get("/order/getExportOrderZipFileS3Url", {params: this.form})
          .then((res) => {
            if (res.code === 200) {
              window.location.href = res.data;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.downloadFailed')
        });
      });
    },
    exportDetail() {
      this.loading = true;
      this.exporting = true;
      this.axios
          .get("/order/selectListForExport?payType=110", {
            params: this.form,
            responseType: "blob",
            timeout: 30 * 60 * 1000
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.collectionOrders.xlsx'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res
                  .text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
            this.exporting = false;
          }).catch((error) => {
        console.log(error);
        this.$notify.error({
          title: this.$t('text.prompt'),
          message: this.$t('message.exportFailed')
        });
        this.exporting = false;
      });
      this.loading = false;
    },
    popBatchBankStatementFileSelect() {
      this.$refs.bankStatementFile.click();
    },
    popBatchCallbackFileSelect() {
      this.$refs.callbackFile.click();
    },
    handleBatchCallbackUpdate() {
      const file = this.$refs.callbackFile;
      const formData = new FormData();
      formData.append("file", file.files[0]);
      this.axios
          .post("/order/bulkUpdateOrderStatus", formData, {
            transformRequest: [
              function (data, headers) {
                delete headers.post["Content-Type"];
                return data;
              }
            ]
          })
          .then((response) => {
            console.log(response);
            this.$notify({
              title: this.$t('text.prompt'),
              message: response.msg,
              type: "success"
            });
            file.value = "";
          })
          .catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.uploadFailed')
            });
            file.value = "";
          });
    },
    popSyncFileSelect() {
      this.$refs.SyncFile.click();
    },
    handleBulkSyncOrderStatus() {
      const file = this.$refs.SyncFile;
      const formData = new FormData();
      formData.append("file", file.files[0]);
      this.axios
          .post("/order/bulkSyncOrderStatus", formData, {
            transformRequest: [
              function (data, headers) {
                delete headers.post["Content-Type"];
                return data;
              }
            ]
          })
          .then((response) => {
            console.log(response);
            this.$notify({
              title: this.$t('text.prompt'),
              message: response.msg,
              type: "success"
            });
            file.value = "";
          })
          .catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.uploadFailed')
            });
            file.value = "";
          });
    },
    importStatement() {
      const file = this.$refs.bankStatementFile;
      const formData = new FormData();
      formData.append("file", file.files[0]);
      this.axios
          .post("/order/importStatement", formData, {
            transformRequest: [
              function (data, headers) {
                delete headers.post["Content-Type"];
                return data;
              }
            ]
          })
          .then((response) => {
            console.log(response);
            this.$notify({
              title: this.$t('text.prompt'),
              message: response.msg,
              type: "success"
            });
            file.value = "";
          })
          .catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.uploadFailed')
            });
            file.value = "";
          });
    },
    validateDate(rule, value, callback) {
      if (!this.createTimeDate && !this.endTimeDate) {
        this.showCreateTimeDateError = this.$t('message.creationTimeOrFinishTimeRequiredError');
        this.showEndTimeDateError = this.$t('message.creationTimeOrFinishTimeRequiredError');
        callback(new Error(this.$t('message.creationTimeOrFinishTimeRequiredError')));
      } else {
        this.showCreateTimeDateError = "";
        this.showEndTimeDateError = "";
        callback();
      }
    },
    showLogDialog() {
      this.isShowLogDialog = true;
    },
  },
  created() {
    this.reset();

    this.$axios
        .get("/merchant/selectListForOption", {params: {}})
        .then((res) => {
          this.merchantList = res.data;
        });

    this.$axios
        .get("/agent/selectAgentForOption", {params: {}})
        .then((res) => {
          this.agentList = res.data;
        });

    this.$axios
        .get("/routeChannelInfo/selectByCondition", {params: {}})
        .then((res) => {
          res.data.map((item) => {
            if (item.productId === '110' && (item.upstream === 'card_group' || item.upstream === 'card_group_management')) {
              this.payOption.push(item);
              if (this.form.channelIds === '') {
                this.form.channelIds = item.channelId;
              } else {
                this.form.channelIds += ',' + item.channelId;
              }
            }
          });
        }).finally(() => {
      this.isShowSearch = true;
    });

    this.$axios.get("/card/selectCardTypeOptions", {params: {}}).then((res) => {
      if (res.code === 200) {
        this.cardTypeList = res.data;
      }
    });
  }
};
</script>

<style scoped>

.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.orderStyle {
  text-align: left;
}

</style>
